/**
 * @fileoverview GET handler for the "/:app_group_id/operator_mcp_connections" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupIdOperatorMcpConnections } from "./constants";
import type { GetAppGroupIdOperatorMcpConnectionsResult } from "./types";
import { isGetAppGroupIdOperatorMcpConnectionsResult } from "./validators";

export const getAppGroupIdOperatorMcpConnections = reactQueryFetcherAdapter(
  appGroupIdOperatorMcpConnections,
  (signal: AbortSignal, appGroupId: string): Promise<GetAppGroupIdOperatorMcpConnectionsResult> => {
    // The page shows its own error, so the global fetch error modal stays out of it.
    return fetch(
      `/${appGroupId}/operator_mcp_connections`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAppGroupIdOperatorMcpConnectionsResult
);
